import { SdgBoxesWithBars } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/sdg-boxes-with-bars';

export function SdgInfoBoxes() {
  // a bit hacky: we use the info boxes component
  // to draw data area stuff, as the SDG lens uses
  // the data area in a way to explicitly supported
  // by the current lens API
  return (
    <>
      <SdgBoxesWithBars />
    </>
  );
}
